import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { EncryptionService } from 'src/app/service/encryption.service';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from 'src/app/service/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DateConversionService } from 'src/app/service/date-conversion.service';
import { Location } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { BottomsheetModalComponent } from '../bottomsheet-modal/bottomsheet-modal.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LoaderComponent } from "../loader/loader.component";
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
import { CleverTapService } from 'src/app/service/clevertap.service';
import clevertap from 'clevertap-web-sdk';

@Component({
    selector: 'app-faq-detail-page',
    standalone: true,
    templateUrl: './subCategory-answers.component.html',
    styleUrls: ['./subCategory-answers.component.less'],
    imports: [CommonModule, ReactiveFormsModule, LoaderComponent]
})
export class subCategoryAnswersComponent {

  queId: string;
  isLoggedIn: string;
  subCategory: string;
  mainCategory: string;  
  convertedDate: string;
  summeryAnswer: string; 
  subCategoryName: string;

  answer: any;
  
  searchListArray = [];

  likeTrue: boolean;
  disLikeTrue: boolean;
  showLoader = false;
  showResults = false;
  showHideSearch = false;
  
  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private encryptionService: EncryptionService,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private router: Router,
    private dateConversionService: DateConversionService,
    private location: Location,
    private fb: FormBuilder,
    private meta: Meta,
    private titleService: Title,
    private _bottomSheet: MatBottomSheet,
    private route: ActivatedRoute,
    private dataService: DataService,
    private constantService: ConstantService,
    private cleverTapService: CleverTapService,
  ) { }

  searchForm = this.fb.group({
    searchText: [null],
  });

  get f() {
    return this.searchForm.controls;
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.queId = params['questionId'];
    });

    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    this.getAnswers();
    this.addMetaTag();
  }

  addMetaTag(): void {
    try{
      this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.createTicketPageRobotContent });
    } catch(e){
      console.log('Error in addMetaTag method - ',e)
    }
  }

  omit_special_char(event) {   
    try {
      var k;  
      k = event.charCode;
      return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 63 || (k >= 48 && k <= 57)); 
    } catch (e) {
      console.log('Error in omit special char method - ', e);
      return false;
    }
  }

  async getAnswers(): Promise<void> {
    try {
      this.showLoader = true;
      const categoryId = this.queId;
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));

      await this.forumApiService.indivisualFaq(portalId, categoryId).then(async (indivisualFaqResponse) => {
        this.answer = indivisualFaqResponse;
        this.convertedDate = this.dateConversionService.convertToRelativeTime(indivisualFaqResponse.modifiedTime);
        this.summeryAnswer = this.answer.answer;
        this.subCategoryName = this.answer.category.name;
        this.showLoader = false;
        this.titleService.setTitle(this.answer.title);
        this.meta.updateTag({ name: this.constantService.description, content: indivisualFaqResponse.summary });
        this.addKeyWords(this.answer.title); 
      });
    } catch (e) {
      this.showLoader = false;
      console.group('Error Occured in getAnswers : ', e);
    }
  }

  async likeArticle(aId: string): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));

      await this.forumApiService.likeArticle(portalId, aId).then(async (likeArticleResponse) => {
        this.likeTrue = true;
        this.disLikeTrue = false;
      });
    } catch (e) {
      this.likeTrue = false;
      this.disLikeTrue = false;
      this.showLoader = false;
      console.group('Error Occured in likeArticle : ', e);
    }
  }

  async disLikeArticle(aId: string): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));

      await this.forumApiService.disLikeArticle(portalId, aId).then(async (disLikeArticleResponse) => {
        this.disLikeTrue = true;
        this.likeTrue = false;
      });
    } catch (e) {
      this.disLikeTrue = false;
      this.likeTrue = false;
      this.showLoader = false;
      console.group('Error Occured in disLikeArticle : ', e);
    }
  }

  goBack(): void {
    try {
      this.location.back();
    } catch(e){
      console.log('Error in goBack method - ',e)
    }
  }

  async searchByString(): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(
        this.storageService.getItem(this.constantService.portalId)
      );
      const searchStr = this.searchForm.controls.searchText.value;
      const from = this.constantService.searchByStringRequestConstant.from;
      const limit = this.constantService.searchByStringRequestConstant.limit;
      const locale = this.constantService.searchByStringRequestConstant.englishLanguage;

      if(this.searchForm.value.searchText == ''){
      this.showResults = false;
      }

      if(this.searchForm.controls.searchText.value != '') {
        await this.forumApiService
        .searchByString(portalId, searchStr, from, limit, locale)
        .then(async (searchByStringResponse) => {
          if(searchByStringResponse.data.length != 0){
            for (let i = 0; i < searchByStringResponse.data.length; i++) {
              this.showResults = true;
              this.searchListArray[i] = searchByStringResponse.data[i];
            }
          } else if(searchByStringResponse.data.length == 0) {
            this.searchListArray = [];
            this.searchListArray[0] = this.constantService.noResultFoundText;
          }
        });
      } else {
        this.searchListArray = [];
      }
      
    } catch (e) {
      console.group('Error Occured in searchByString : ', e);
      this.searchListArray = [];
      this.searchListArray[0] = this.constantService.noResultFoundText;
    }
  }

  goTosubCategoryAnswers(questionId: string, catId: string, questionTitle: string): void {
    try {
      this.showHideSearch = false;    
      this.showResults = false;
      this.queId = questionId;

      if(this.storageService.getItem(this.constantService.isLoggedIn) == this.constantService.yes){
        clevertap.init('R74-5R4-6W5Z');

        setTimeout(() => {
          const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
          clevertap.onUserLogin.push({
            "Site": {
                "Identity": clientId
            }
           });

          let clevertapData = {
            action : 'search',
            page_section : 'search',
            keyword : this.searchForm.controls.searchText.value,
            client_code : clientId
          };    
          this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);

        }, 3000);
      }

      this.dataService.data.subscribe((mainCategoryArray) => {
        mainCategoryArray.forEach(mainCat => {
          mainCat.child.forEach(subCat => {
            if(subCat.id == catId){
              this.mainCategory = mainCat.permalink;
              this.subCategory = subCat.permalink;
            }
          });
        });
      });
      this.getAnswers();
    this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});

    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ',e)
    }
  }

  changeHeader(): void {
    try {
      this.searchListArray = [];
      this.searchForm.controls.searchText.setValue('');
      this.showHideSearch = true;
    } catch(e){
      console.log('Error in changeHeader method - ',e)
    }
  }

  closeSearchBar(): void {
    try {
      this.showHideSearch = false;
    } catch(e){
      console.log('Error in closeSearchBar method - ',e)
    }
  }

  goToCreateTicket(): void {
    try {
     this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
 
     if(this.isLoggedIn == this.constantService.yes) {
       clevertap.init('R74-5R4-6W5Z');
       setTimeout(() => {
         const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
         clevertap.onUserLogin.push({
           "Site": {
               "Identity": clientId
           }
          });
 
         let clevertapData = {
           action : 'create_ticket',
           page_section : 'support',
           client_code : clientId
         };
         this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
       }, 3000);
       this.router.navigateByUrl('ticketCreation',{ state: { isFromAnswers: this.constantService.yes } });
     } else {
       this._bottomSheet.open(BottomsheetModalComponent, {
         data: { message: this.constantService.notLoggedInMessage }
       });
     }
    } catch(e){
     console.error("Error in goToCreateTicket method - ",e);
    }
   }

   letsChat(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    if(this.isLoggedIn == this.constantService.yes) {
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": clientId
          }
        });
        let clevertapData = {
          action : 'chat',
          page_section : 'support',
          client_code : clientId
        };
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
        window.location.href = this.constantService.letsChatBotLink;
      }, 1000);
    } else {
      this._bottomSheet.open(BottomsheetModalComponent, {
        data: { message: this.constantService.notLoggedInMessage }
      });
    }    
  }

  addKeyWords(keywords: string): void {
    try{
      var pos = require('pos');
      var words = new pos.Lexer().lex(keywords);
      var tagger = new pos.Tagger();
      var taggedWords = tagger.tag(words);
      var output=[];
      for (let i in taggedWords) {
          var taggedWord = taggedWords[i];
          var word = taggedWord[0];
          var tag = taggedWord[1];
          //check if tag is a noun or adjective
          if(tag.indexOf('NN')==0 || tag.indexOf('JJ')==0)
            output.push(word);
          var str = output.join(", "); 
      }
      this.meta.updateTag({ name: 'keywords', content: str });
    } catch (e){
      console.log('Error in addKeyWords Method - ',e);
    }
  }   

}
